export const contingentTreeIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 32"><path d="M1 17c0-7 9-15 9-15s9 8.083 9 15a9 9 0 11-18 0z" stroke="#1ABC9C" stroke-width="2" stroke-miterlimit="10" stroke-linecap="square"/><path d="M10 11v20M4 31h12M5 16l5 5 5-5" stroke="#1ABC9C" stroke-width="2" stroke-miterlimit="10"/></svg>`,
  name: 'tree',
};
